import { useState } from 'react';
import { BiLineChart } from 'react-icons/bi'; // Importa un icono alternativo
import { FaExternalLinkAlt, FaJava } from 'react-icons/fa';
import { FaSquareGitlab } from 'react-icons/fa6';
import { SiAxios, SiBootstrap, SiCss3, SiDotnet, SiHtml5, SiJavascript, SiJquery, SiLaravel, SiPostgresql, SiReact, SiRedux, SiSpring, SiVite } from 'react-icons/si';
import { FaDatabase, FaFileAlt } from 'react-icons/fa';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import project1Image from '/src/assets/project1.png?height=200&width=300';
import project2Image from '/src/assets/project2.png?height=200&width=300';
import project3Image from '/src/assets/project3.png?height=200&width=300';
import project4Image from '/src/assets/project4.png?height=200&width=300';
import project5Image from '/src/assets/project5.png?height=200&width=300';
import project6Image from '/src/assets/project6.png?height=200&width=300';
import project7Image from '/src/assets/project7.png?height=200&width=300';
import project8Image from '/src/assets/project8.png?height=200&width=300';
import project9Image from '/src/assets/project9.png?height=200&width=300';
import project10Image from '/src/assets/project10.png?height=200&width=300';

// Función para obtener el icono de tecnología correspondiente
function getTechIcon(tech) {
  const iconMap = {
    'Java': FaJava,
    'Swing': FaJava,
    'Apache Ant': null,
    'JavaScript': SiJavascript,
    'HTML': SiHtml5,
    'CSS': SiCss3,
    'C#': SiDotnet,
    '.NET Core': SiDotnet,
    'Laravel': SiLaravel,
    'Spring Boot': SiSpring,
    'Bootstrap': SiBootstrap,
    'jQuery': SiJquery,
    'JasperReports': FaFileAlt,
    'Wildfly': null,
    'Glassfish': FaJava,
    'PostgreSQL': SiPostgresql,
    'Primefaces': FaJava,
    'JSF': FaJava,
    'JPA': FaDatabase,
    'React': SiReact,
    'Redux': SiRedux,
    'Vite': SiVite,
    'Axios': SiAxios,
    'ApexCharts': BiLineChart,
  };

  return iconMap[tech] || null;
}

export default function Projects() {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const projects = [
    {
      title: 'Mobility-Purchase',
      description: 'Application developed by Mobility Solutions that allows you to manage purchases and stock efficiently and effectively for the Ministry of Tourism (MINTUR).',
      image: project1Image,
      technologies: ['Java', 'Wildfly', 'Primefaces', 'JSF', 'JPA', 'PostgreSQL', 'JasperReports'],
      gitlabLink: 'https://gitlab.com/javaeeprojects/mobility-purchase.git',
      liveLink: '',
    },
    {
      title: 'Mobility-Schedule',
      description: 'Project that seeks to facilitate the programming and reservation of meeting rooms within the Ministry of Tourism (MINTUR).',
      image: project2Image,
      technologies: ['Java', 'Wildfly', 'Primefaces', 'JSF', 'JPA', 'PostgreSQL', 'JasperReports'],
      gitlabLink: 'https://gitlab.com/javaeeprojects/mobility-schedule.git',
      liveLink: '',
    },
    {
      title: 'Mobility-TS',
      description: 'Enterprise Java EE application for comprehensive travel expense management at the Ministry of Tourism (MINTUR). Features multi-level approval workflows, financial tracking, automated notifications, and performance monitoring with EJB interceptors. Built with modern Java EE architecture including JPA, JSF, and PrimeFaces.',
      image: project3Image,
      technologies: ['Java', 'Glassfish', 'Primefaces', 'JSF', 'JPA', 'PostgreSQL', 'JasperReports'],
      gitlabLink: 'https://gitlab.com/javaeeprojects/mobility-ts.git',
      liveLink: '',
    },
    {
      title: 'Backoffice System',
      description: 'Backend system developed in Laravel to manage the internal operation of the entire system. It is an integral part of a broader system called Reasix IT Solutions.',
      image: project4Image,
      technologies: ['Laravel', 'Livewire', 'PHP', 'SQL Server', 'Bootstrap', 'Docker', 'PHPUnit'],
      gitlabLink: 'https://gitlab.com/laravelwebprojects/backoffice.git',
      liveLink: '',
    },
    {
      title: 'Census Management System',
      description: 'This project aims to carry out a census of the population in a certain geographical area. The census will be carried out by collecting demographic and socioeconomic data of the inhabitants of the area.',
      image: project5Image,
      technologies: ['HTML', 'CSS', 'JavaScript', 'Local Storage', 'JSON', 'AJAX', 'Bootstrap', 'jQuery'],
      gitlabLink: 'https://censo-js-app.pages.dev/',
      liveLink: '',
    },
    {
      title: 'Stationery Supplies Order Management System',
      description: 'This project is a stationery supply order management system developed in C# with .NET Core. It allows businesses to manage orders, customers, items, and more.',
      image: project6Image,
      technologies: ['C#', '.NET Core', 'Entity Framework Core', 'SQL Server'],
      gitlabLink: 'https://gitlab.com/csharpwebprojects/Papeleria.git',
      liveLink: '',
    },
    {
      title: 'Marvel Web API Application ACCSA V2.0',
      description: 'Web application that integrates the Marvel API and queries the Marvel API to find all characters by id.',
      image: project7Image,
      technologies: ['Java', 'Spring Boot', 'Thymeleaf', 'Marvel API'],
      gitlabLink: 'https://gitlab.com/springbootprojects8051603/marvelAPI.git',
      liveLink: '',
    },
    {
      title: 'Baby Tracker',
      description: 'Baby tracking application developed with React + Vite. Features include complete authentication (Login/Register), activity management with filters, real-time statistics and metrics (time tracking, activity logs, historical data) and user management functionalities. Built with React 19, Vite, Redux Toolkit, React Router, Bootstrap.',
      image: project8Image,
      technologies: ['React', 'Vite', 'Redux', 'React Router', 'Bootstrap'],
      gitlabLink: 'https://gitlab.com/reactnativeprojects/baby-tracker.git',
      liveLink: 'https://baby-tracker-app.pages.dev/',
    },
    {
      title: 'Multiplayer Poker System',
      description: 'Multiplayer poker game system implemented with Java 19 and Swing. Players can participate in poker tables, place bets and compete against each other. Includes user management, table administration, betting system and game statistics. Implements design patterns such as Strategy, State, Observer, Singleton, MVC and Facade.',
      image: project9Image,
      technologies: ['Java', 'Swing', 'JDK 19', 'Apache Ant', 'Git'],
      gitlabLink: 'https://gitlab.com/javaswingprojects/sistemapoker.git',
      liveLink: '',
    },
    {
      title: 'MoveTrack App',
      description: 'Web application developed with React + Vite for tracking physical activities. Features include complete authentication (Login/Register), activity management with filters, statistics and graphs (time per activity, temporal evolution, general metrics), and a responsive interface. Built with React 19, Vite, Redux Toolkit, React Router, Bootstrap, Axios, ApexCharts.',
      image: project10Image,
      technologies: ['React', 'Redux', 'Vite', 'Bootstrap', 'Axios', 'ApexCharts'],
      gitlabLink: 'https://gitlab.com/reactnativeprojects/movetrack-app.git',
      liveLink: 'https://movetrack-app.vercel.app',
    },
  ];

  // Función para manejar el clic en una imagen
  const handleImageClick = (image, index) => {
    const images = projects.map((project) => ({
      original: project.image,
      thumbnail: project.image,
      description: project.title,
    }));

    setGalleryImages(images);
    setCurrentIndex(index);
    setIsGalleryOpen(true);
  };

  // Función para cerrar la galería de imágenes
  const handleCloseGallery = () => {
    setIsGalleryOpen(false);
  };

  return (
    <section id='projects' data-section='projects' className='container mx-auto w-full scroll-m-20 md:max-w-2xl lg:max-w-4xl section undefined'>
      <h2 className='flex gap-x-3 items-center mb-6 text-3xl font-semibold dark:text-white text'>
        <svg className='size-7' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor' fill='none' strokeLinecap='round' strokeLinejoin='round'>
          <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
          <path d='M7 8l-4 4l4 4'></path>
          <path d='M17 8l4 4l-4 4'></path>
          <path d='M14 4l-4 16'></path>
        </svg>
        Projects
      </h2>
      <div className='flex flex-col gap-y-16'>
        {projects.map((project, index) => (
          <article
            key={index}
            className='flex flex-col space-x-0 space-y-8 md:flex-row md:space-x-8 md:space-y-0 group'>
            <div className='w-full md:w-1/2'>
              <div className='flex relative flex-col col-span-6 row-span-5 gap-8 items-center overflow-clip rounded-xl shadow-xl transition duration-500 ease-in-out transform lg:border-gray-800 lg:hover:border-gray-700 lg:hover:bg-gray-800/50 md:group-hover:shadow-2xl lg:border sm:rounded-xl md:group-hover:-translate-y-1'>
                <img
                  src={project.image}
                  alt={project.title}
                  className='object-cover object-top w-full h-56 transition duration-500 md:group-hover:scale-105 sm:h-full md:scale-110'
                  loading='lazy'
                  onClick={() => handleImageClick(project.image, index)}
                />
              </div>
            </div>
            <div className='w-full md:w-1/2 md:max-w-lg'>
              <h3 className='text-2xl font-bold dark:text-gray-100 color-text'>
                {project.title}
              </h3>
              <div className='flex flex-wrap gap-2 mt-2'>
                <ul className='flex flex-row flex-wrap gap-x-2 mb-2'>
                  {project.technologies.map((tech, techIndex) => {
                    const IconComponent = getTechIcon(tech)
                    return (
                      <li key={techIndex}>
                        <span className={`flex gap-x-2 ${IconComponent === FaJava ? 'bg-gray-500' : 'bg-[#003159]'} ${IconComponent === SiLaravel ? 'bg-red-800' : 'bg-[#003159]'} ${IconComponent === SiBootstrap ? 'bg-purple-800' : 'bg-[#003159]'} ${IconComponent === SiPostgresql ? 'bg-[#037cb3]' : 'bg-[#003159]'} mb-1 px-2 py-1 rounded-full text-white text-xs`}>
                          {IconComponent && (
                            <IconComponent className='flex-shrink-0 w-4 h-4' />
                          )}
                          {tech}
                        </span>
                      </li>
                    )
                  })}
                </ul>
                <div className='mt-2 text-gray-700 dark:text-gray-400'>
                  {project.description}
                </div>
                <footer className='flex gap-x-4 justify-start items-end mt-4'>
                  <a
                    href={project.gitlabLink}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='inline-flex justify-center items-center gap-2 space-x-2 border-gray-300 hover:border-gray-900 dark:border-gray-600 bg-gray-100 hover:bg-gray-800 dark:hover:bg-[#4B5564] active:bg-black dark:bg-gray-800 px-3 py-2 border rounded-xl focus-visible:ring focus-visible:ring-yellow-500/80 focus-visible:ring-white focus-visible:ring-offset-2 max-w-fit text-base text-gray-800 text-md hover:text-white dark:text-white transition group focus:outline-none focus-visible:outline-none'>
                    <FaSquareGitlab size={24} />
                    Code
                  </a>
                  {project.liveLink && (
                    <a
                      href={project.liveLink}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='inline-flex gap-2 justify-center items-center px-3 py-2 space-x-2 text-base text-gray-800 bg-gray-100 rounded-xl border border-gray-300 transition hover:border-gray-900 dark:border-gray-600 hover:bg-gray-800 active:bg-black dark:bg-gray-800 focus-visible:ring focus-visible:ring-yellow-500/80 focus-visible:ring-white focus-visible:ring-offset-2 max-w-fit text-md hover:text-white dark:text-white group focus:outline-none focus-visible:outline-none'>
                      <FaExternalLinkAlt size={24} />
                      Preview
                    </a>
                  )}
                </footer>
              </div>
            </div>
          </article>
        ))}
      </div>

      {isGalleryOpen && (
        <div
          className='flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-75'
          onClick={handleCloseGallery}
          onKeyDown={(e) => e.key === 'Escape' && handleCloseGallery()}
          tabIndex={0}
          role="dialog"
          aria-modal="true"
          aria-label="Image gallery"
        >
          <div className='w-full max-w-3xl' onClick={(e) => e.stopPropagation()}>
            <ImageGallery
              items={galleryImages}
              startIndex={currentIndex}
              showThumbnails={true}
              showFullscreenButton={true}
              showPlayButton={false}
              onSlide={(index) => setCurrentIndex(index)}

              onImageLoad={(event) => {
                if (event.target.src.includes('error')) {
                  console.error('Failed to load image:', event.target.src);
                }
              }}
            />
            <button
              className='absolute top-5 right-5 text-xl text-white'
              onClick={handleCloseGallery}
              aria-label="Close gallery"
            >
              Close
            </button>
          </div>
        </div>
      )}

    </section>
  )
}
